export default class FileItem {
  static cloneWithoutContents(files) {
    return files.map((file) => {
      const emptyFile = new FileItem();
      emptyFile.path = file.path;
      emptyFile.binary = file.binary;
      if (file.blob) {
        emptyFile.size = file.blob.size;
      }
      return emptyFile;
    });
  }

  constructor(path = null) {
    this.path = path;
  }

  name() {
    return this.path.split(/[\\/]/g).pop();
  }

  foldersArray() {
    const arr = this.path.split(/[\\/]/g);
    arr.pop();
    return arr;
  }

  folders() {
    return this.foldersArray().join('/');
  }

  extension() {
    return /[.]/.exec(this.path)
      ? /[^.]+$/.exec(this.path)[0]
      : undefined;
  }
}
